export default __webpack_public_path__ + "a26eb4c50f017670de77845310cb40d4.png";